export default {
	TYPE_MYSHIFTPLANNER: 'type_myshiftplanner',
	TYPE_IN_TABLE: 'type_in_table',
	TYPE_PHONE: 'type_phone',
	TYPE_HOTDAMNBAR: 'type_hotdamnbar',
	TYPE_JUICER_DETAILS: 'type_juicer_details',
	TYPE_JUICER_DETAILS_PHONE: 'type_juicer_details_phone',
} as const;
